export enum UserTypeEnum {
    Educator = 0,
    Consultant = 1,
  }